export enum VacancyOrderType {
  DATE = "DATE",
  BONUS = "BONUS",
}
